import * as angular from "angular";
import {IController} from "angular";
import {ServicePointModel} from "../../angular/models/service-point.model";

export class ServicePointsTableRowCtrl implements IController {

  servicePoint: ServicePointModel;
  onDelete: Function;
  onEdit: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.service-points')
  .component('servicePointsTableRow', {
    bindings: {
      servicePoint: '<',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./service-points-table-row.html').default,
    controller: ServicePointsTableRowCtrl
  });
